import helper from '../helpers/api';
import api from '../configs/api';

const resource = 'customer-service-info';

export default {
  ...helper(resource),
  getOne: (id) => api.get(`${resource}/${id}`),
};
